import BaseCtrl from 'edge/platform/base/BaseCtrl';

var fn = function fn($scope, claimViewModel) {
    var ctrl = Object.create(BaseCtrl);

    ctrl.init = function () {
        $scope.claimVm = claimViewModel();
    };

    ctrl.next = function (nextFn) {
        nextFn($scope.claimVm);
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', 'claimViewModel'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/fnol/general/controllers/GeneralWhereCtrl.js
// module id = 1546
// module chunks = 0